import React from "react";
import { HandHeart, TrendingUp, Mail, BadgeCheck, Activity } from "lucide-react";
import { STATS } from "@/lib/brand";
import { CountUp } from "@/components/CountUp";

const impact = [
  { num: "1", label: "Buch", text: "schenkt einem Kind Sicherheit." },
  { num: "20", label: "Bücher", text: "rüsten eine Schulklasse aus." },
  { num: "100", label: "Plüsch-Paulas", text: "begleiten 100 RTW-Einsätze." },
];

export const Sponsors = () => {

const liveStats = [
  {
    end: STATS.buecherVerkauft,
    label: "Bücher bereits in Kinderhänden",
    sub: "Stand: laufend aktualisiert",
  },
  {
    end: STATS.pluschPaulasPrototyp,
    label: "Plüsch-Paula Prototyp",
    sub: "Der Anfang einer großen Vision",
  },
  {
    end: 112,
    label: "Notruf, den jedes Kind kennen sollte",
    sub: "Paulas wichtigste Lektion",
  },
];

  return (
    <section
      id="foerderer"
      data-testid="sponsors-section"
      className="relative py-24 sm:py-32 bg-paula-blue text-white overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -bottom-32 -right-20 w-[480px] h-[480px] rounded-full bg-white/10 blur-3xl"
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        {/* Live impact banner */}
        <div
          data-testid="live-impact-banner"
          className="mb-14 rounded-3xl bg-white/10 border border-white/20 backdrop-blur p-6 sm:p-8"
        >
          <div className="flex items-center gap-2 mb-6">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-paula-yellow opacity-75" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-paula-yellow" />
            </span>
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-paula-yellow">
              Live · Paulas Wirkung
            </span>
            <Activity size={14} className="text-paula-yellow ml-1" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 lg:gap-8">
            {liveStats.map((s) => (
              <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, '-').slice(0,30)}`}>
                <div className="font-display font-black text-5xl sm:text-6xl text-paula-yellow leading-none tracking-tight">
                  <CountUp end={s.end} suffix={s.suffix || ""} />
                </div>
                <div className="mt-3 font-display font-semibold text-white leading-snug">
                  {s.label}
                </div>
                <div className="text-white/65 text-xs mt-1">{s.sub}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-white/80 mb-4">
            Für Förderer & Stifter
          </div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl leading-[1.05] tracking-tight">
            Werden Sie Teil dieser{" "}
            <span className="text-paula-yellow">Bewegung.</span>
          </h2>
          <p className="mt-6 text-white/85 text-lg leading-relaxed">
            Paula ist kein Produkt. Paula ist ein Versprechen — an Kinder, an
            Familien, an unsere Gesellschaft. Mit Ihrer Unterstützung wird aus
            der Vision Realität.
          </p>

          <div className="mt-10 space-y-4">
            <div className="flex items-start gap-3">
              <BadgeCheck className="text-paula-yellow flex-shrink-0 mt-0.5" size={22} />
              <div>
                <div className="font-display font-semibold">
                  Direkte Wirkung
                </div>
                <div className="text-white/80 text-sm">
                  Jeder Euro landet bei einem Kind — als Buch, als Plüschtier,
                  als Lernstunde.
                </div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <BadgeCheck className="text-paula-yellow flex-shrink-0 mt-0.5" size={22} />
              <div>
                <div className="font-display font-semibold">
                  Transparente Verwendung
                </div>
                <div className="text-white/80 text-sm">
                  Wir zeigen, wohin Ihre Spende geht. Mit Bildern, Berichten,
                  echten Geschichten.
                </div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <BadgeCheck className="text-paula-yellow flex-shrink-0 mt-0.5" size={22} />
              <div>
                <div className="font-display font-semibold">
                  Sichtbarkeit als Partner
                </div>
                <div className="text-white/80 text-sm">
                  Förderer können auf Wunsch sichtbar werden — bei
                  Veranstaltungen, in Schulen, online.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          {/* Impact cards */}
          <div className="grid sm:grid-cols-3 gap-4 mb-6">
            {impact.map((i) => (
              <div
                key={i.label}
                data-testid={`impact-${i.label.toLowerCase()}`}
                className="p-6 rounded-3xl bg-white/10 border border-white/20 backdrop-blur"
              >
                <div className="font-display font-bold text-5xl text-paula-yellow leading-none">
                  {i.num}
                </div>
                <div className="mt-2 font-display font-semibold text-lg">
                  {i.label}
                </div>
                <div className="text-white/75 text-sm mt-1">{i.text}</div>
              </div>
            ))}
          </div>

          {/* CTA Card */}
          <div className="rounded-3xl bg-white text-paula-ink p-8 lg:p-10">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-2xl bg-paula-blue-soft grid place-items-center">
                <HandHeart className="text-paula-blue" size={22} />
              </div>
              <h3 className="font-display font-bold text-2xl">
                Wirkung gestalten
              </h3>
            </div>
            <p className="text-paula-muted leading-relaxed">
              Ob als Einzelspende, Unternehmenspartnerschaft oder
              Stiftungs-Kooperation — sprechen Sie uns an. Wir bauen Paulas
              Vision gemeinsam.
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href="mailto:fallersimone@googlemail.com?subject=Paula%20unterst%C3%BCtzen"
                data-testid="sponsors-contact-cta"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-paula-ink text-white font-semibold hover:bg-paula-blue transition-colors"
              >
                <Mail size={18} />
                Förderer-Gespräch starten
              </a>
              <a
                href="mailto:fallersimone@googlemail.com?subject=Spende%20-%20Pinguin%20Paula"
                data-testid="sponsors-donate-cta"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-paula-yellow text-paula-ink font-semibold hover:bg-paula-yellow/80 transition-colors"
              >
                <TrendingUp size={18} />
                Direkt spenden
              </a>
            </div>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
};

export default Sponsors;
